module.exports = __webpack_public_path__ + "static/media/12UNCTAD15.85c84b10.jpg";